import { SpinnerOverlay } from 'components/SpinnerOverlay'
import { SudoOverlay } from 'components/SudoOverlay'
import { ModalProvider } from 'components/SudoOverlay/contexts'
import { Suspense } from 'react'
import { Sidebar, SidebarProvider } from './Sidebar'
import { Sidebar as NewSidebar } from './NewSidebar'
import { Route } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { GlobalHeader } from 'ui/components/GlobalHeader'
import classNames from 'classnames'
import { useActiveFeatureFlags } from 'contexts/SiteConfig'

const SidebarLayout = ({ children }) => {
  const featureFlags = useActiveFeatureFlags()
  const contentSectionClasses = classNames(
    'flex flex-col w-full flex-1 relative h-full overflow-hidden style-reset'
  )

  return (
    <div className="overflow-hidden h-screen flex flex-col md:flex-row bg-gray-50 dark:bg-gray-800">
      <SidebarProvider>
        <QueryParamProvider ReactRouterRoute={Route}>
          {!featureFlags.includes('expandable_nav') && <Sidebar />}

          {featureFlags.includes('expandable_nav') && <NewSidebar />}

          <div className={contentSectionClasses}>
            <GlobalHeader />
            <ModalProvider>
              <div className="overflow-y-auto">
                <Suspense fallback={<SpinnerOverlay />}>{children}</Suspense>
              </div>
              <SudoOverlay />
            </ModalProvider>
          </div>
        </QueryParamProvider>
      </SidebarProvider>
    </div>
  )
}

export default SidebarLayout
